import React, { useCallback } from 'react';
import { Table } from '@colonist/ui-platform';
import { useFriendsTableColumns } from './FriendsTableColumns/useFriendsTableColumns.tsx';
import styles from './FriendsTable.module.scss';
/** Friends list table with online status, activity, and gift button. */ export const FriendsTable = ({ friends, onUserClick, onGiftClick })=>{
    const columns = useFriendsTableColumns({
        onGiftClick: onGiftClick
    });
    const handleRowClick = useCallback((row)=>{
        onUserClick(row.userId, row.username);
    }, [
        onUserClick
    ]);
    return /*#__PURE__*/ React.createElement(Table, {
        testId: "profile-friends-table",
        className: styles.container,
        data: friends,
        columns: columns,
        density: "comfortable",
        onRowClick: handleRowClick,
        emptyText: {
            key: 'strings:profilePage.friends.tabs.friends.defaultBody'
        },
        showEmptyText: friends.length == 0
    });
};
